// extracted by mini-css-extract-plugin
module.exports = {"expander":"prhk3C8i4Q6jEIYeDKrQ","dataTypeLabel":"F9hJdcYVFSgJuWlzRoMf"};